import { render, staticRenderFns } from "./CheckoutSettings.vue?vue&type=template&id=65587457&scoped=true"
import script from "./CheckoutSettings.vue?vue&type=script&lang=js"
export * from "./CheckoutSettings.vue?vue&type=script&lang=js"
import style0 from "./CheckoutSettings.vue?vue&type=style&index=0&id=65587457&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65587457",
  null
  
)

export default component.exports